import Telegram from './telegram';

export default Telegram;
